import React, { useEffect } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import './styleDetails.css'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { loadOneWarehouses } from '../../../../store/Actions/ActionWarehouses'
import { useParams } from 'react-router-dom'
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader'

function Index() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { one_warehouse, loadingOneWarehouses } = useSelectorCustom()
    let { id } = useParams()
    useEffect(() => {
        dispatch(loadOneWarehouses(id))
    }, [])

    return (
        <>
            <main>
                <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ position: "relative" }} >
                    {
                        loadingOneWarehouses ? <InnerLoader /> :
                            <div className='div_details_warehouse' >
                                <div>
                                    <h3>{one_warehouse?.name}</h3>
                                    <div className='row_details' >
                                        <div>
                                            <span className='title' >City</span>
                                            <span>{one_warehouse?.city}</span>
                                        </div>
                                        <div>
                                            <span className='title' >Country</span>
                                            <span>{one_warehouse?.country}</span>
                                        </div>
                                        <div>
                                            <span className='title' >location</span>
                                            <span>{one_warehouse?.location}</span>
                                        </div>
                                        <div>
                                            <span className='title' >Phone</span>
                                            <span>{one_warehouse?.phone_number}</span>
                                        </div>
                                        <div>
                                            <span className='title' >Status</span>
                                            <span>{one_warehouse?.status ? 'Valid' : "Un Valid"}</span>
                                        </div>
                                        <div>
                                            <span className='title' >Notes</span>
                                            <span>{one_warehouse?.notes}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='row_bottom' >
                                    <div className='div_product' >
                                        <div className='d-flex' >
                                            <h3>Materilas</h3>
                                            <div className='num-of-thing' >12</div>
                                        </div>

                                        <div className='one_pro' style={{ marginTop: '10px' }} >
                                            <input placeholder='Search ...' />
                                            <i className='fa fa-search search_pro' ></i>
                                        </div>
                                        <div className='one_pro' >
                                            <p>name</p>
                                            <p>type </p>
                                            <p>1000</p>
                                        </div>
                                        <div className='one_pro' >
                                            <p>name</p>
                                            <p>type </p>
                                            <p>1000</p>
                                        </div>
                                        <div className='one_pro' >
                                            <p>name</p>
                                            <p>type </p>
                                            <p>1000</p>
                                        </div>
                                        <div className='one_pro' >
                                            <p>name</p>
                                            <p>type </p>
                                            <p>1000</p>
                                        </div>
                                        <div className='one_pro' >
                                            <p>name</p>
                                            <p>type </p>
                                            <p>1000</p>
                                        </div>
                                        <div className='btns_pro' >
                                            <button className='prev_pro' >Prev</button>
                                            <button className='prev_next' >Next</button>
                                        </div>
                                    </div>
                                    <div className='line_between' ></div>
                                    <div className='div_orders'>
                                        <div className='d-flex' >
                                            <h3>Orders</h3>
                                            <div className='num-of-thing' >12</div>
                                        </div>
                                        <div className='one_pro' style={{ marginTop: '10px' }} >
                                            <input placeholder='Search ...' />
                                            <i className='fa fa-search search_pro' ></i>
                                        </div>
                                        <div className='one_pro' >
                                            <p>name</p>
                                            <p>type </p>
                                            <p>1000</p>
                                        </div>
                                        <div className='one_pro' >
                                            <p>name</p>
                                            <p>type </p>
                                            <p>1000</p>
                                        </div>
                                        <div className='one_pro' >
                                            <p>name</p>
                                            <p>type </p>
                                            <p>1000</p>
                                        </div>
                                        <div className='one_pro' >
                                            <p>name</p>
                                            <p>type </p>
                                            <p>1000</p>
                                        </div>
                                        <div className='one_pro' >
                                            <p>name</p>
                                            <p>type </p>
                                            <p>1000</p>
                                        </div>
                                        <div className='btns_pro' >
                                            <button className='prev_pro' >Prev</button>
                                            <button className='prev_next' >Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }

                </div>
            </main>
        </>
    )
}

export default Index